import { render, staticRenderFns } from "./DailogBoxNew.vue?vue&type=template&id=f947d032"
import script from "./DailogBoxNew.vue?vue&type=script&lang=js"
export * from "./DailogBoxNew.vue?vue&type=script&lang=js"
import style0 from "./DailogBoxNew.vue?vue&type=style&index=0&id=f947d032&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports